export default "__VITE_ASSET__I90c6eZr__"